<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="userId" >
                        <span slot="label" ><a-tooltip>用户ID<template slot="title">用户ID</template></a-tooltip> </span>
                        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+'用户ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="payType" >
                        <span slot="label" ><a-tooltip>支付类型 1=支付宝 2=微信<template slot="title">支付类型 1=支付宝 2=微信</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="realName" >
                        <span slot="label" ><a-tooltip>真实姓名<template slot="title">真实姓名</template></a-tooltip> </span>
                        <a-input v-model="form.realName" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'真实姓名'" />
                  </a-form-model-item>
                  <a-form-model-item prop="mobile" >
                        <span slot="label" ><a-tooltip>绑定手机号<template slot="title">绑定手机号</template></a-tooltip> </span>
                        <a-input v-model="form.mobile" :maxLength="20" :placeholder="$t('通用.输入.请输入')+'绑定手机号'" />
                  </a-form-model-item>
                  <a-form-model-item prop="qrCodeUrl" >
                        <span slot="label" ><a-tooltip>收款二维码图片地址<template slot="title">收款二维码图片地址</template></a-tooltip> </span>
                        <a-input v-model="form.qrCodeUrl" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="status" v-if="formType === 2">
                        <span slot="label" ><a-tooltip>状态 0待审核 1已绑定 2审核失败 3已禁用<template slot="title">状态 0待审核 1已绑定 2审核失败 3已禁用</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="rejectReason" >
                        <span slot="label" ><a-tooltip>驳回原因<template slot="title">驳回原因</template></a-tooltip> </span>
                        <a-input v-model="form.rejectReason" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'驳回原因'" />
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getPaymentBind, addPaymentBind, updatePaymentBind } from '@/api/user/paymentBind'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          userId: null,
                          payType: null,
                          realName: null,
                          mobile: null,
                          qrCodeUrl: null,
                      status: 0,
                          rejectReason: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              userId: [{ required: true, message: '用户ID'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              mobile: [{ required: true, message: '绑定手机号'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              qrCodeUrl: [{ required: true, message: '收款二维码图片地址'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          userId: null,
                          payType: null,
                          realName: null,
                          mobile: null,
                          qrCodeUrl: null,
                      status: 0,
                          rejectReason: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPaymentBind({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updatePaymentBind(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addPaymentBind(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
